<div class="card" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
  <div class="card-body">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h3 style="text-align: center;" fxFlex="100">{{getTitle(requestType.selfPayTypeCode)}}</h3>
    </div>
    <div *ngIf="selfPay.isRetireeInitial" class="container-fluid">
      <p>
        PEBB retiree insurance coverage is available to more than only employees who are retiring. It may also include separated employees who are at least 55 years of age
        and meet specific retirement plan and years of service requirements and who will not yet receive a monthly retirement plan payment. 
        If you are a retiring employee or eligible separating employee, the PEBB Program must receive your retiree enrollment or deferral request and any other required documents 
        no later than 60 days after your own employer-paid, COBRA, or continuation coverage ends.  
      </p>
      <p>
        For additional information and timelines regarding retiree enrollment please see
        <a href="https://www.hca.wa.gov/employee-retiree-benefits/preparing-retirement" target="_blank">Preparing for retirement</a> 
      </p>
      <p>
        Note: If you are enrolling in PEBB retiree insurance coverage, in some cases, we cannot enroll you until we receive your first payment of monthly premiums and applicable premium 
        surcharges.  You must make your first payment no later than 45 days after your 60-day election period ends.  
      </p>
    </div>
    <div *ngIf="!selfPay.isSOE && !selfPay.isRetireeInitial" class="container-fluid">
      <p *ngIf="!selfPay.isOE">
        A request for {{selfPay.agency.agencyCode}} Continuation Coverage {{selfPay.isCobraInitial ? '(COBRA)' : ''}} {{selfPay.isLwopInitial ? '(Unpaid Leave)': ''}}
        must be submitted no later than 60 days after the date your {{selfPay.agency.agencyCode}} health plan coverage ends, or from the postmark date on the election notice sent by the {{selfPay.agency.agencyCode}} Program, whichever is later.
      </p>
      <p *ngIf="!selfPay.isOE">
        Your first premium payment and applicable premium surcharges are due to HCA no later than 45 days after your
        60-day election period ends. HCA only accepts cash, check, or money order for payment. We will not enroll you in coverage until we receive your first payment.
        If HCA does not receive your first payment {{ selfPay.isPebbCobraInitial ? 'before the end of' : 'during' }} this 45-day timeframe, you will not be enrolled,
        and you will lose your rights for {{selfPay.agency.agencyCode}} Continuation Coverage {{selfPay.isCobraInitial ? '(COBRA)' : '(Unpaid Leave)'}}.
        Premiums and applicable premium surcharges are due from the date your other coverage ended.
        See  <a target="_blank" [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/SEBB-continuation-coverage/paying-benefits' : 'https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/paying-benefits'">Paying for benefits</a> for more information.
      </p>
      <p *ngIf="selfPay.isRetireeOE">
        Complete this form to make changes during the PEBB Program's annual open enrollment. Forms must be received by the PEBB Program during the open enrollment period, 
        October 26 through November 23, 2026. 
      </p>
      <p *ngIf="selfPay.isRetireeOE">
        Changes that are made during open enrollment may result in changes to premium payments and applicable premium surcharges.  These payments are due
        to the Health Care Authority (HCA) after the effective date of the changes.
      </p>
      <p *ngIf="selfPay.isCobraOE || selfPay.isLwopOE">
        Changes that are made during open enrollment may result in changes to premium payments and applicable premium surcharges. These payments are due to the
        Health Care Authority (HCA) after the effective date of the changes.
      </p>
    </div>

    <div *ngIf="selfPay.isSOE" class="container-fluid">
      <soe-instructions isSelfPay="true"
          [subscriber]="subscriber"
          [isCobra]="selfPay.isCOBRA"
          [isRetiree]="selfPay.isRetiree"
          [isLwop]="selfPay.isLWOP"          
       ></soe-instructions>
      <p>
        Select the applicable event from the list below (check one)
      </p>
      <ul style="list-style:none;">
        <li *ngFor="let soeType of selfPayTypesList; let index = index" class="mgbt-medium-lg">
          <div>
            <checkbox
              [name]="'soeType-' + index"
              [checked]="selectedSoeType?.specialOpenEnrollmentTypeId === soeType.specialOpenEnrollmentTypeId"
              (click)="selectSoeType(soeType)"
              [label]="soeType.specialOpenEnrollmentTypeName"
            ></checkbox>
            <div>
              <ng-container *ngIf="showCustomSOEDescription">
                <ng-container *ngIf="selectedSoeType?.specialOpenEnrollmentTypeCode === 'COC'">
                  You or your dependent experience a disruption of care for active and ongoing treatment that could function as a reduction in benefits. 
                  Requires approval by the {{subscriber?.agencyCode}} Program.<br /><br />
                </ng-container>
                <ng-container *ngIf="selectedSoeType.specialOpenEnrollmentTypeCode === 'MDP'">
                  As defined by <a href="https://apps.leg.wa.gov/wac/default.aspx?cite=182-31-020" target="_blank">Washington Administrative Code (WAC) 182-30-020</a>.<br /><br />
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!showCustomSOEDescription && selectedSoeType?.specialOpenEnrollmentTypeDescription && selectedSoeType?.specialOpenEnrollmentTypeId === soeType.specialOpenEnrollmentTypeId">
                {{selectedSoeType?.specialOpenEnrollmentTypeDescription}}
                <br /><br />
              </ng-container>
              <span>Documents to submit:</span>
              <ul>
                <ng-container *ngIf="displaySPCustomDocs(soeType.specialOpenEnrollmentTypeCode)">
                  <ng-container *ngIf="soeType.specialOpenEnrollmentTypeCode === 'GLEMO'">
                    <li>Medicare benefit verification letter</li>
                    <li>Copy of Medicare card</li>
                    <li>Letter/Notice of Denial of Medicare coverage</li>
                    <li>Social Security denial letter</li>
                    <li>Medicare Entitlement or Cessation of Disability form</li>
                    <li>Letter confirming enrollment or cancellation of Medicare Part D enrollment</li>
                    <li>Letter of declination of Medicare Part D coverage</li>
                    <li>Letter confirming enrollment or cancellation of MA or MAPD</li>
                    <li>Letter of declination of MA or MAPD</li>
                  </ng-container>
                  <ng-container  *ngIf="soeType.specialOpenEnrollmentTypeCode === 'CA'">
                    <li>
                      <li>Proof of former and current residence (e.g. utility bill)</li>
                      <li>Certificate of creditable coverage</li>
                  </ng-container>
                  <ng-container *ngIf="soeType.specialOpenEnrollmentTypeCode === 'MDP'">
                    <li>Marriage certificate</li>
                    <li>Certificate of state-registered domestic partnership or legal union and {{selfPay.agency.agencyCode}} Declaration of Tax Status form</li>
                  </ng-container>
                  <ng-container *ngIf="soeType.specialOpenEnrollmentTypeCode === 'MPNLA'">
                    <li>Cancellation letter from the high deductible health plan</li>
                    <li>Copy of current tax return claiming you as a dependent</li>
                    <li>Coverage confirmation in a new health plan</li>
                    <li>Medicare benefit verification letter</li>
                  </ng-container> 
                  <ng-container *ngIf="soeType.specialOpenEnrollmentTypeCode === 'NEED'">
                    <li>Court order showing legal custody, guardianship, or temporary guardianship; and</li>
                    <li>{{selfPay.agency.agencyCode}} Extended Dependent Certification Form; and</li>
                    <li>{{selfPay.agency.agencyCode}} Declaration of Tax Status form</li>
                  </ng-container>
                  <ng-container *ngIf="soeType.specialOpenEnrollmentTypeCode === 'LOC'">
                    <li>Certificate of creditable coverage</li>
                    <li>Letter of termination of coverage from health plan</li>
                    <li>COBRA election notice if it is personalized to the person who lost coverage and includes the date coverage was lost</li>
                  </ng-container>
                  <ng-container *ngIf="soeType.specialOpenEnrollmentTypeCode === 'CES'">
                    <li>Employee hire letter from employer that contains information about benefits eligibility</li>
                    <li>Employment contract</li>
                    <li>Letter of resignation</li>
                    <li>Statement of insurance</li>
                    <li>Termination letter</li>
                  </ng-container>
                  <ng-container *ngIf="soeType.specialOpenEnrollmentTypeCode === 'DCES'">
                    <li>Certificate of coverage</li>
                    <li>Employee hire letter from employer that contains information about benefits eligibility</li>
                    <li>Employment contract</li>
                    <li>Letter of resignation</li>
                    <li>Statement of insurance</li>
                    <li>Termination letter</li>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!displaySPCustomDocs(soeType.specialOpenEnrollmentTypeCode)">
                  <ng-container *ngIf="showCustomSOEDocTypes">
                    <ng-container *ngIf="selectedSoeType.specialOpenEnrollmentTypeCode === 'GLEMC'">
                      <li>Enrollment or termination letter from Medicaid or CHIP reflecting the date the employee or employee's dependent enrolled in Medicaid or CHIP or the date 
                        at which they lost eligibility for Medicaid or CHIP</li>
                    </ng-container>
                    <ng-container *ngIf="selectedSoeType.specialOpenEnrollmentTypeCode === 'MDP'">
                      <li>Marriage certificate</li>
                      <li>Certificate of state-registered domestic partnership or legal union and the 
                        <a href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=20-0087&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_customer_type_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort_bef_combine=name_ASC" target="_blank">SEBB Declaration of Tax Status</a>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="selectedSoeType.specialOpenEnrollmentTypeCode === 'NEED'">
                      <li>Valid court order showing legal custody, guardianship, or temporary guardianship, signed by a judge or officer of the court, a signed 
                        <a href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=extended+dependent+certification&field_customer_type_tid=19011&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort=filename+ASC" target="_blank">{{subscriber?.agencyCode || 'PEBB'}} Extended Dependent Certification</a>
                        , and <a href="https://www.hca.wa.gov/employee-retiree-benefits/forms-and-publications?combine=Declaration+of+Tax+Status&field_customer_type_tid=19011&field_pebb_document_type_value_selective=All&field_peb_topic_tid=All&field_year_tid_selective=All&field_erb_plan_tid_selective=All&sort=filename+ASC" target="_blank">{{subscriber?.agencyCode || 'PEBB'}} Declaration of Tax Status</a>.
                      </li>
                    </ng-container>            
                  </ng-container>
                  <ng-container *ngIf="!showCustomSOEDocTypes">
                    <li *ngFor="let docType of soeType?.documentTypes">{{docType.documentTypeName}}</li>
                  </ng-container>
                </ng-container>                
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around">
      <!-- <button (click)="pushCancel()" class="btn btn-secondary">{{cancelButtonLabel(requestType.selfPayTypeCode)}}</button> -->
      <button (click)="pushContinue()" [disabled]="!canContinue(requestType, selectedSoeType)" class="btn btn-primary">{{continueButtonLabel(requestType.selfPayTypeCode)}}</button>
    </div>
  </div>
</div>
